function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.001,
    viewBox: "0 0 24 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-pause",
    d: "M6.75 28.5h6.669v-24H6.75zm13.332-24v24h6.669v-24z",
    transform: "translate(-4.75 -4.5)",
    style: {
      fill: "#204bf8"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.06298e88e84c96138483543ff11fa11e.svg";
export { ForwardRef as ReactComponent };